import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ZkSyncIcon() {
    return (_jsxs("svg", { className: "ui-size-full", viewBox: "0 0 22 13", fill: "currentColor", children: [_jsx("path", { d: "M22 6.22551L15.7557 0.00933838V4.55912L9.5583 9.11827H15.7557V12.4417L22 6.22551Z" }), _jsx("path", { d: "M0 6.22553L6.24426 12.4417V7.92L12.4417 3.3234H6.24426V0L0 6.22553Z" })] }));
}
export default ZkSyncIcon;
